module.exports = __webpack_public_path__ + "static/media/lb-close-light.2291abef.svg";